/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StartTimecardRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {StartTimecardResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const startTimecard = (request: StartTimecardRequest, options?: CashRequestOptions) => post<StartTimecardRequest, StartTimecardResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/StartTimecard", request, {...options, rejectOnError: true })